import { render } from "./UserWalletItemList.vue?vue&type=template&id=1b08b048&scoped=true&ts=true"
import script from "./UserWalletItemList.vue?vue&type=script&lang=ts"
export * from "./UserWalletItemList.vue?vue&type=script&lang=ts"

import "./UserWalletItemList.vue?vue&type=style&index=0&id=1b08b048&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b08b048"]])

export default __exports__